module.exports = __webpack_public_path__ + "static/media/gplay.a56a361a.png";